import request from './request';
import { getCookie } from "@/helpers";

const getOfferNotesList = async (offerId) => {
    try {
        const result = await request.post(`/graphql`, {
                query: `
          {
            offerNotesList(offerId: ${offerId}) {
              id
              note
              author
              email
              dateAdded
            }
          }
        `
            },
            {
                headers: {
                    'Authorization': getCookie('accessToken'),
                    'Referrer-Police': 'strict-origin-when-cross-origin',
                    'Access-Control-Allow-Origin': '*',
                    'workspace': localStorage.getItem('workspace') || 'ac'
                }
            }
        );

        return result.data.data.offerNotesList;
    } catch (err) {
        console.error(`Error fetching offer notes: ${err}`);
        throw err;
    }
};

const createOfferNote = async (data) => {
    try {
        const result = await request.post(`/graphql`, {
                query: `
            mutation {
              createOfferNote(
                note: """${data.note}""",
                offerId: ${data.offerId}
              ) {
                id
              }
            }
          `
            },
            {
                headers: {
                    'Authorization': getCookie('accessToken'),
                    'Referrer-Police': 'strict-origin-when-cross-origin',
                    'Access-Control-Allow-Origin': '*',
                    'workspace': localStorage.getItem('workspace') || 'ac'
                }
            }
        );

        return result.data.data.createOfferNote;
    } catch (err) {
        console.error(`Error creating offer note: ${err}`);
        throw err;
    }
};

const updateOfferNote = async (data) => {
    try {
        const note = data.note.replace(/`/g, '\\`');
        const result = await request.post(`/graphql`, {
                query: `
            mutation {
              updateOfferNote(
                note: """${note}""",
                id: ${data.id},
                isDelete: ${data.isDelete}
              )
            }
          `
            },
            {
                headers: {
                    'Authorization': getCookie('accessToken'),
                    'Referrer-Police': 'strict-origin-when-cross-origin',
                    'Access-Control-Allow-Origin': '*',
                    'workspace': localStorage.getItem('workspace') || 'ac'
                }
            }
        );

        return result.data.data.updateOfferNote;
    } catch (err) {
        console.error(`Error updating offer note: ${err}`);
        throw err;
    }
};

export default {
    getOfferNotesList,
    createOfferNote,
    updateOfferNote
};
